export default class HttpError extends Error {
  constructor({
    message,
    statusCode,
    path,
    method,
    xRequestId,
    headers
  }) {
    super();
    this.name = 'HttpError';
    this.message = message;
    const p = path.split('?')[0];
    this.path = /^[/-a-z]+$/i.test(p) ? p : '';
    this.method = method;
    this.statusCode = statusCode;
    this.xRequestId = xRequestId;
    this.headers = Array.from(headers.entries()).map((value, key) => `${key}:${value}`).sort().join(',');
  }
}
export const isHttpError = e => e instanceof HttpError;